import { Syncable } from "shared/state/models/syncable";
import { IDrugType } from "shared/api/api";


export const SAVE_DRUGTYPE = 'SAVE_DRUGTYPE';
export const SYNC_DATA_DRUGTYPES = 'SYNC_DATA_DRUGTYPES';

export interface DrugTypeState extends Syncable<IDrugType> {}
